import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { History, FolderOpen, Trash2, Loader2 } from "lucide-react";
import api, { formatMoney, formatNumber } from "../../lib/api";

const SEG = { all: "Todo", farmacia: "Farmacia", parafarmacia: "Parafarmacia" };

export function PedidosGuardados({ lab, recarga, onAbrir }) {
  const [rows, setRows] = useState(null);
  const [abriendo, setAbriendo] = useState("");

  useEffect(() => {
    api.get("/lab-analisis/pedidos", { params: { laboratorio: lab } }).then((r) => setRows(r.data.pedidos)).catch(() => setRows([]));
  }, [lab, recarga]);

  const abrir = async (p) => {
    setAbriendo(p.id);
    try { onAbrir((await api.get(`/lab-analisis/pedidos/${p.id}`)).data); }
    catch { toast.error("No se pudo abrir el pedido"); } finally { setAbriendo(""); }
  };
  const borrar = async (p) => {
    if (!window.confirm("¿Borrar este pedido guardado?")) return;
    try { await api.delete(`/lab-analisis/pedidos/${p.id}`); setRows((r) => r.filter((x) => x.id !== p.id)); toast.success("Pedido borrado"); }
    catch { toast.error("No se pudo borrar el pedido"); }
  };

  if (!rows?.length) return null;
  return (
    <div className="card p-6" data-testid="la-pedidos-guardados">
      <h3 className="font-display text-lg font-bold flex items-center gap-2"><History size={18} className="text-sky-700" /> Pedidos guardados de {lab}</h3>
      <p className="text-xs text-slate-500 mb-3">Abre uno para consultarlo, retocarlo o volver a descargarlo tal como lo guardaste.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b">
            <th className="py-2 pr-3">Fecha</th><th>Canal</th><th>Familia</th><th className="num">Días</th><th className="num">Uds</th><th className="num">Importe</th><th /></tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="border-b border-slate-100" data-testid={`la-guardado-${p.id}`}>
                <td className="py-2 pr-3 font-semibold">{new Date(p.created_at).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" })}</td>
                <td>{SEG[p.segment] || p.segment}</td><td>{p.familia || "Todas"}</td>
                <td className="num">{p.dias}</td><td className="num">{formatNumber(p.total_uds)}</td><td className="num">{formatMoney(p.total_importe)}</td>
                <td className="text-right whitespace-nowrap">
                  <button onClick={() => abrir(p)} className="btn btn-outline btn-sm" data-testid={`la-guardado-abrir-${p.id}`}>
                    {abriendo === p.id ? <Loader2 size={14} className="animate-spin" /> : <FolderOpen size={14} />} Abrir</button>
                  <button onClick={() => borrar(p)} className="ml-2 p-2 rounded-md text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors" aria-label="Borrar" data-testid={`la-guardado-borrar-${p.id}`}><Trash2 size={15} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
